import { PerAccountLocalStorage, StorageKeys } from '../../services/PerAccountLocalStorage';

const STORAGE_KEY = 'noornote_tribes_addon_enabled';

export function isTribesEnabled(): boolean {
  const perAccount = PerAccountLocalStorage.getInstance().get<boolean | null>(
    StorageKeys.TRIBES_ADDON_ENABLED, null
  );
  if (perAccount !== null) return perAccount;
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

export function setTribesEnabled(enabled: boolean): void {
  PerAccountLocalStorage.getInstance().set(StorageKeys.TRIBES_ADDON_ENABLED, enabled);
  // Global fallback used before login (per-account storage has no pubkey yet) — must
  // reflect the actual state, otherwise the sidebar entry stays hidden on next launch.
  localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
}
